import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import {UserService} from "../../../services/user.service";

@Injectable()
export class LogFiltersFactory extends FiltersFactory {
    constructor(private localStorage: LocalStorage,
                private commonHelper: CommonHelper,
                private dropdownItemFactory: DropdownItemFactory,
                private userService: UserService,
                private dropdownSettingFactory: DropdownSettingsFactory) { super() }

    async build(filters, localStorageFilterKey = 'logs') {
        filters.user.list = this.dropdownItemFactory.build({ source: await this.userService.getAllUsersAsResponsibles() });
        filters.verb.list = this.dropdownItemFactory.build({ source: await this.commonHelper.getVerbs() });

        filters.user.options = this.dropdownSettingFactory.build({ text: 'Usuários' });
        filters.verb.options = this.dropdownSettingFactory.build({ text: 'Ações' });

        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/logs/filters.factory.ts